import { TableColumn } from '../../models/table-column';
import { BadgeComponentsEnum } from '../../enums/badge-components.enum';
import { TextKeys } from '../../i18n/text-keys';

export function getTableColumns(): TableColumn[] {
  return [
    {
      name: BadgeComponentsEnum.WorkInfo,
      text: TextKeys.badge.workInfo,
      selected: true,
      position: 0,
      disabled: true,
    } as TableColumn,
    {
      name: BadgeComponentsEnum.Saldo,
      text: TextKeys.dayInfo.overview,
      selected: true,
      position: 1,
    } as TableColumn,
    {
      name: BadgeComponentsEnum.Note,
      text: TextKeys.note.title,
      selected: true,
      position: 2,
    } as TableColumn,
    {
      name: BadgeComponentsEnum.Material,
      text: TextKeys.material.title,
      selected: false,
      position: 3,
    } as TableColumn,
    {
      name: BadgeComponentsEnum.Quantity,
      text: TextKeys.quantity.title,
      selected: false,
      position: 4,
    } as TableColumn,
    {
      name: BadgeComponentsEnum.Expense,
      text: TextKeys.expenses.title,
      selected: false,
      position: 5,
    } as TableColumn,
    {
      name: BadgeComponentsEnum.Terminate,
      text: TextKeys.general.terminate,
      selected: false,
      position: 6,
    } as TableColumn,
  ] as TableColumn[];
}

export function defaultSettingsForStandardChrono(): TableColumn[] {
  const defaultSettings: TableColumn[] = getTableColumns();
  defaultSettings.forEach((setting) => {
    if (setting.name == BadgeComponentsEnum.Saldo) {
      setting.disabled = false;
      setting.selected = true;
    } else if (setting.name == BadgeComponentsEnum.WorkInfo) {
      setting.disabled = true;
      setting.selected = true;
    } else if (setting.name == BadgeComponentsEnum.Expense) {
      setting.disabled = false;
      setting.selected = false;
    } else if (setting.name == BadgeComponentsEnum.Note) {
      setting.disabled = false;
      setting.selected = true;
    } else {
      setting.disabled = true;
      setting.selected = false;
    }
  });
  return defaultSettings;
}
